<template>
	<div>
		<el-form label-position="top" :model="formFor" :rules="rules" ref="form">
			<div v-for="(v,i) in formFor.list" :key="i">
				<div class="delete">
					<div>
						<span class="delete-title">{{'预算明细('+(i+1)+')'}}</span>
					</div>
					<div class="delCur" @click="del(v,i)">
						<i class="el-icon-error icon-color"></i>
						<span class="delete-title">删除</span>
					</div>
				</div>
				<el-form-item label="支出科目" :prop="'list.'+i+'.paysubject'" :rules="rules.paysubject">
					<el-input v-model="v.paysubject" placeholder="请输入支出科目" clearable></el-input>
				</el-form-item>
				<el-row class="floor-two" :gutter="20">
					<el-col :span="12">
						<el-form-item label="单价" :prop="'list.'+i+'.unitprice'" :rules="rules.unitprice">
							<el-input v-model="v.unitprice" placeholder="请输入单价" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="数量" :prop="'list.'+i+'.amount'" :rules="rules.amount">
							<el-input-number v-model="v.amount" :min="1" :max="100" label="描述文字"></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注" :prop="'list.'+i+'.remarks'" :rules="rules.remarks">
					<el-input v-model="v.remarks" type="textarea" :rows="5" placeholder="请输入备注" clearable></el-input>
				</el-form-item>
			</div>
		</el-form>
		<div class="btn">
			<el-button type="primary" @click="baocen()">全部保存</el-button>
		</div>
		<div class="addForm">
			<el-button class="addBtn" icon="el-icon-plus" type="text" @click="add">增加到报销明细</el-button>
		</div>
		<yincan :content="projectbubget.inputtip"></yincan>
		<!-- <div class="fz-FF0000">
			提示：项目执行经费并非奖金，用于“与绿同行”项目执行使用，实际支付以所获奖次对应金额为准，应考虑必要支出科目，金额预算，并进行成本控制。
			项目预算，包括但不限于：活动物料、交通、通讯、误餐、饮水、意外保险、项目成果（视频制作、彩色印制）等等。
		</div> -->
		<div class="btns">
			<bottomButtons rightWord="提交" @childrenDoPre="childrenDoPre" @childrenDoNext="childrenDoNext" />
		</div>
	</div>
</template>
<script>
	import bottomButtons from "../../../components/bottomButtons.vue";
	import yincan from "../../../components/yincan.vue";
	import {
		saveProject,
		saveProjectBudget,
		deleteProjectBudget,
		updateProjectBudget,
		getProjectBudgetList,
		getProjectType
	} from "../../../api/signUp";
	import res from "../../../utils/msg";
	import msg from "../../../utils/msg";
	const addForm = {
		paysubject: "",
		unitprice: "",
		amount: "",
		remarks: "",
	};
	export default {
		components: {
			bottomButtons,
			yincan
		},
		data() {
			return {
				typechoose: '',
				formFor: {
					list: [{
						paysubject: "", //
						unitprice: "",
						amount: 1,
						remarks: "",
					}, ],
				},
				form: {
					project_id: "", // 项目 id
					school: "", // 学校名称
					team: "", // 团队
					name: "", // 项目名称
					project_type_id: "", // 项目类型
					teacher: "", // 指导老师
					teacherphone: "", // 老师联系方式
					dutyperson: "", // 项目负责人
					dutypersonphone: "", // 项目负责人联系方式
					address: "", // 通讯地址
					introduce: "", // 项目简介
					innovate: "", // 项目创新点
					activitytime: "", // 活动时间
					activityaddress: "", // 活动地点
					activityobject: "", // 活动对象
					step: "", // 步骤
					risk: "", // 项目风险
					target: "", // 预期目标
				},
				rules: {
					paysubject: [{
						required: true,
						message: "请输入支出科目",
						trigger: "blur"
					}, ],
					unitprice: [{
						required: true,
						message: "请输入单价",
						trigger: "blur"
					}],
					amount: [{
						required: true,
						message: "请输入数量",
						trigger: "blur"
					}],
					remarks: [{
						required: false,
						message: "请输入备注",
						trigger: "blur"
					}],
				},
				projectbubget:{},//步骤
			};
		},
		mounted() {
			console.log(this.formFor.list);
			setTimeout(() => {
				this.getLable()
			}, 1500);
			this.gettype()
		},
		methods: {
			getLable(){
				this.projectbubget = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'projectbubget')
			},
			gettype() {
				getProjectType().then(res => {
					this.typechoose = res.data.value
				})
			},
			async getFather_step5(data) {
				this.form = data;
				await this.getYusuanList();
			},
			childrenDoPre() {
				this.$parent.doPre();
			},
			// 保存预算
			edit(v, i) {
				const _this = this;
				_this.$refs.form.validate(async (valid) => {
					if (valid) {

						if (v.id) {
							let _data = {
								project_id: this.form.project_id||this.form.id,
								...v,
							};
							try {
								let updateRes = await updateProjectBudget(_data);
								console.log(updateRes, "更新预算");
								if (updateRes.data.code == 1) {
									res.success(updateRes.data.msg);
									await this.getYusuanList();
								} else {
									res.error(updateRes.data.msg);
								}
							} catch (error) {
								// console.log(error);
							}
						} else {
							let _data = {
								project_id: this.form.project_id||this.form.id,
								...v,
							};
							try {
								let saveRes = await saveProjectBudget(_data);
								console.log(saveRes, "添加预算");
								if (saveRes.data.code == 1) {
									res.success(saveRes.data.msg);
									await this.getYusuanList();
								} else {
									res.error(saveRes.data.msg);
								}
							} catch (error) {
								// console.log(error);
							}
						}

					}
				});
			},
			async baocen() {
				let unitprice = this.formFor.list.some(item => item.unitprice == 0.00 || item.unitprice == '0.00');
				if (unitprice) {
					res.success("请补全预算信息");
					return
				}
				let flag = this.formFor.list.every(v => {
					return v.paysubject && v.unitprice && v.unitprice
				});
				if (!flag) {
					res.success("请补全预算信息");
					return
				};
				const promises = this.formFor.list.map(async (item) => {
				    item.project_id = this.form.project_id||this.form.id;
				    if (item.id) {
				        let _data = {
				            project_id: this.form.project_id||this.form.id,
				            ...item,
				        };
				        try {
				            let updateRes = await updateProjectBudget(_data);
				            if (updateRes.data.code === 1) {
				                res.success(updateRes.data.msg);
				                await this.getYusuanList();
				            } else {
				                res.error(updateRes.data.msg);
				            }
				        } catch (error) {
				            // console.log(error);
				        }
				    } else {
				        let _data = {
				            project_id: this.form.project_id||this.form.id,
				            ...item,
				        };
				        console.log('没有没有没有', _data);
				        try {
				            let saveRes = await saveProjectBudget(_data);
				            console.log(saveRes, "添加预算");
				            if (saveRes.data.code === 1) {
				                res.success(saveRes.data.msg);
				                await this.getYusuanList();
				            } else {
				                res.error(saveRes.data.msg);
				            }
				        } catch (error) {
				            // console.log(error);
				        }
				    }
				});
				
				await Promise.all(promises);
			},
			// 删除预算
			async del(v, i) {
				console.log(v, "删除v");
				// 如果有id就调接口删除如果没有就前端页面直接干掉
				if (v.id) {
					let _data = {
						id: v.id,
					};
					try {
						let updateRes = await deleteProjectBudget(_data);
						if (updateRes.data.code === 1) {
							res.success(updateRes.data.msg);
							await this.getYusuanList();
						} else {
							res.error(updateRes.data.msg);
							await this.getYusuanList();
						}
					} catch (error) {
						// console.log(error);
					}
				} else {
					this.formFor.list.forEach((v1, i1) => {
						if (i1 == i) {
							this.formFor.list.splice(i1, 1);
						}
					});
				}

			},
			// 添加
			add() {
				this.formFor.list.push({
					...addForm
				});
			},
			// 查询预算
			async getYusuanList() {
				let _data = {
					project_id: this.form.project_id||this.form.id,
				};
				try {
					let findRes = await getProjectBudgetList(_data);
					this.formFor.list = findRes.data.data;
				} catch (error) {
					console.log(error);
				}
			},
			childrenDoNext() {
				this.baocen()
				const _this = this;
				if (_this.formFor.list.length == 0 || _this.formFor.list == '' || !_this.formFor.list) {
					_this.$message({
						message: '预算不能为空',
						type: 'warning'
					});
					return;
				}
				_this.$refs.form.validate(async (valid) => {
					if (valid) {
						let _data = {
							...this.form,
							project_id: _this.form.project_id||_this.form.id,
							iscg: 2,
						};
						// 把 project_type_id 转为逗号分隔的字符串
						if (this.typechoose == 1) {
							let newProjectTypeStrs = "";
							for (const v of _data.project_type_ids) {
								newProjectTypeStrs += v + ",";
							}
							newProjectTypeStrs = newProjectTypeStrs.substring(
								0,
								newProjectTypeStrs.length - 1
							);
							_data.project_type_ids = newProjectTypeStrs;
						}
						try {
							let saveRes = await saveProject(_data);
							if (saveRes.data.code == 1) {
								this.$message.success('更新成功');
								setTimeout(() => {
									_this.$parent.doNext();
									_this.$router.push({
										name: "success"
									});
								}, 1500);
							} else {
								res.error(saveRes.data.msg);
							}
						} catch (error) {
							console.log(error);
						}
					}
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.delete {
		widows: 100%;
		height: 18px;
		padding: 8px 16px;
		background: #fef0f0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 4px;

		&>div {
			display: flex;
			align-content: center;
		}
	}

	.icon-color {
		color: #f56c6c;
	}

	.delete-title {
		color: #f56c6c;
		font-size: 12px;
		line-height: 16px;
	}

	.delCur {
		cursor: pointer;
	}

	.floor-two {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.btn {
		padding-bottom: 50px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
	}

	.addForm {
		width: 100%;
		display: flex;
		justify-content: center;
		align-content: center;

		.addBtn {
			color: #4ab428;
		}
	}

	.btns {
		margin-top: 30px;
		position: relative;

		.add {
			width: 20%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	.fz-FF0000 {
		color: #ff0000;
		font-size: 14px;
	}
</style>